import { render, staticRenderFns } from "./SkillRate.vue?vue&type=template&id=5f52c156&scoped=true&"
import script from "./SkillRate.vue?vue&type=script&lang=ts&"
export * from "./SkillRate.vue?vue&type=script&lang=ts&"
import style0 from "./SkillRate.vue?vue&type=style&index=0&id=5f52c156&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52c156",
  null
  
)

export default component.exports